import { render, staticRenderFns } from "./PhenotypeHallmark.vue?vue&type=template&id=651389de&scoped=true"
import script from "./PhenotypeHallmark.vue?vue&type=script&lang=js"
export * from "./PhenotypeHallmark.vue?vue&type=script&lang=js"
import style0 from "./PhenotypeHallmark.vue?vue&type=style&index=0&id=651389de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651389de",
  null
  
)

export default component.exports